import { render, staticRenderFns } from "./CRResultDetail.vue?vue&type=template&id=07322adc&scoped=true"
import script from "./CRResultDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./CRResultDetail.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CRResultDetail.vue?vue&type=style&index=0&id=07322adc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07322adc",
  null
  
)

export default component.exports